
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/holiday-store",
      function () {
        return require("private-next-pages/explore/holiday-store.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/holiday-store"])
      });
    }
  